import { connect } from "react-redux";

import { setUsersettings } from "~/store/ducks/user/uistate";

import UsersettingsModal from "./UsersettingsModal";

const mapDispatchToProps = {
  setUsersettings
};

export default connect(null, mapDispatchToProps)(UsersettingsModal);
